import * as ActionTypes from '../constants/actionTypes';
import objectAssign from 'object-assign';
import { getErrorMessage } from '../utils/error-parser';
import initialState from './initialState';


export default function authentication(state = initialState.authentication, action) {
  switch (action.type) {
    case ActionTypes.LOGIN_REQUEST:
      return objectAssign({}, state, {
        loggingIn: true,
        error: ""
      });
    case ActionTypes.LOGIN_SUCCESS:
      return objectAssign({}, state, {
        loggedIn: true,
        loggingIn: false,
        error: "",
        logInMultiAccount:action.user.authorization.multipleAccount,
        data:action.user
      });
    case ActionTypes.LOGIN_FAILURE:
      return objectAssign({}, state, {
        loggedIn: false,
        loggingIn: false,
        error: getErrorMessage(action.error.errorCode)
      });
      case ActionTypes.CREATE_USER_REQUEST:{
        return objectAssign({}, state, {
          loggingIn: true,
          error: ""
        });
      }
      case ActionTypes.CREATE_USER_SUCCESS:{
        return objectAssign({}, state, {
          loggedIn: true,
          loggingIn: false,
          error: "",
          data:action.user
        });
      }
      case ActionTypes.CREATE_USER_FAILURE:
        return objectAssign({}, state, {
        loggedIn: false,
        loggingIn: false,
        error: getErrorMessage(action.error.errorCode)
      });
      case ActionTypes.LOGOUT:
      return objectAssign({}, state, {
        loggedIn: false,
        error: "",
        logInMultiAccount:false,
        data:{}
      });
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/loginReducer.js